// extracted by mini-css-extract-plugin
export var circle = "_1v-2";
export var icon = "_1v-a";
export var iconHighlight = "_1v-0";
export var lg = "_1v-8";
export var md = "_1v-7";
export var outline = "_1v-4";
export var sm = "_1v-6";
export var square = "_1v-1";
export var xl = "_1v-9";
export var xs = "_1v-5";
export var xxs = "_1v-3";